import { supabase } from '@/integrations/supabase/client';
import { setStepImageOverrides } from './step-images';

let loaded = false;
let loadingPromise: Promise<void> | null = null;

/**
 * Scans the `video-frames` storage bucket and registers the most recent
 * non-starter image per stepKey as a runtime override for STEP_IMAGES.
 *
 * File naming convention (set by generate-step-image and the admin sequence):
 *   `${stepKey}-${timestamp}.png|jpg|webp`            → final image
 *   `${stepKey}-starter-${timestamp}.png|jpg|webp`    → video starter frame (ignored)
 *
 * Idempotent — call once at app startup.
 */
export async function loadLovableImageOverrides(): Promise<void> {
  if (loaded) return;
  if (loadingPromise) return loadingPromise;

  loadingPromise = (async () => {
    const { data, error } = await supabase.storage
      .from('video-frames')
      .list('', { limit: 1000, sortBy: { column: 'created_at', order: 'asc' } });

    if (error) {
      console.warn('[lovable-image-overrides] load failed', error);
      return;
    }

    const map: Record<string, string> = {};
    for (const f of data ?? []) {
      // Match `${stepKey}-${timestamp}.ext` but skip `-starter-` files
      const m = f.name.match(/^(.+?)(-starter)?-\d+\.(?:jpg|jpeg|png|webp)$/i);
      if (!m) continue;
      if (m[2]) continue; // starter frames are intermediate assets
      const stepKey = m[1];
      const { data: pub } = supabase.storage.from('video-frames').getPublicUrl(f.name);
      // ascending order ⇒ later writes overwrite, so newest wins
      map[stepKey] = pub.publicUrl;
    }

    setStepImageOverrides(map);
    loaded = true;
  })();

  return loadingPromise;
}
